import { F0Card } from '@factorialco/f0-react'
import { RichTextDisplay } from '@factorialco/f0-react/dist/experimental'
import { Delete, Pencil } from '@factorialco/f0-react/icons/app'
import { ComplaintsNotesQuery } from 'generated/resources/graphql'

import { buildUrl } from 'modules/core/lib/buildUrl'
import { FORMAT, stringToDate } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'

import RitchTextEditorForNotes from './RitchTextEditorForNotes'

interface NoteCardProps {
  note: ComplaintsNotesQuery['complaints']['notesConnection']['edges'][number]['node']
  showEditor: boolean
  noteText: string
  onEdit: (initialText: string) => void
  onDelete: (noteId: number) => void
  onDiscardEdit: () => void
  onChange: (text: string) => void
  onSave: () => void
}

function NoteCard({
  note,
  showEditor,
  noteText,
  onEdit,
  onDelete,
  onDiscardEdit,
  onChange,
  onSave,
}: NoteCardProps) {
  return (
    <>
      {!showEditor && (
        <F0Card
          data-testid="card"
          key={note.id + '_note_card'}
          title={note.employee.firstName + ' ' + note.employee.lastName}
          description={
            '· ' + stringToDate(note.createdAt, 'backend_datetime').format(FORMAT.ui_date_with_time)
          }
          avatar={{
            type: 'person',
            firstName: note.employee.firstName,
            lastName: note.employee.lastName,
            ...(note.employee.avatar?.url && { src: buildUrl(note.employee.avatar.url) }),
          }}
          compact
          otherActions={[
            {
              label: i18n.t('complaints.overview.internal_notes.edit'),
              icon: Pencil,
              onClick: () => onEdit(note.text),
            },
            {
              label: i18n.t('complaints.overview.internal_notes.delete'),
              icon: Delete,
              critical: true,
              onClick: () => onDelete(note.id),
            },
          ]}
        >
          <RichTextDisplay content={note.text} />
        </F0Card>
      )}
      {showEditor && (
        <RitchTextEditorForNotes
          key={note.id + '_note_editor'}
          onDiscard={onDiscardEdit}
          onChange={onChange}
          onSave={onSave}
          noteText={noteText}
          initialNoteText={note.text}
          title={i18n.t('complaints.overview.internal_notes.update_note')}
        />
      )}
    </>
  )
}

export default NoteCard
